// extracted by mini-css-extract-plugin
export var completionBody = "_lw-2";
export var completionCard = "_lw-0";
export var completionFooter = "_lw-3";
export var completionTitle = "_lw-1";